import type { JSX } from "react";
import type { TextStyle, ViewStyle } from "react-native";

export type PlateStyle = {
  container?: ViewStyle;
  text?: TextStyle;
  header?: ViewStyle;
  countryName?: TextStyle;
  customPlate?: (plate: string) => JSX.Element;
};

export const COUNTRIES = [
  {
    label: "United States",
    value: "US",
    iso: "us",
    flag: "🇺🇸",
    coords: { latitude: 39.8283, longitude: -98.5795 },
    nearby: ["CA", "MX"],
  },
  {
    label: "Canada",
    value: "CA",
    iso: "ca",
    flag: "🇨🇦",
    coords: { latitude: 56.1304, longitude: -106.3468 },
    nearby: ["US"],
  },
  {
    label: "Mexico",
    value: "MX",
    iso: "mx",
    flag: "🇲🇽",
    coords: { latitude: 23.6345, longitude: -102.5528 },
    nearby: ["US"],
  },
  {
    label: "United Kingdom",
    value: "GB",
    iso: "gb",
    flag: "🇬🇧",
    coords: { latitude: 55.3781, longitude: -3.436 },
    nearby: ["IE", "FR", "DE", "NL"],
  },
  {
    label: "Paraguay",
    value: "PY",
    iso: "py",
    flag: "🇵🇾",
    coords: { latitude: -23.442503, longitude: -58.443832 },
    nearby: ["AR", "BR", "BO", "UY"],
    phonePrefix: "+595",
    phoneRegex: /^[0-9]{9,10}$/,
    phonePlaceholder: "9XX XXX XXX",
    phoneMaxLength: 10,
    phoneNumberCheck: (num: string) => num.replace(/^0+/, ""),
    vehiclePlatePlaceholder: "AAAA123",
    vehiclePlateRegexes: {
      car: /^[A-Z]{3}\d{3}$/i,
      mercosurCar: /^[A-Z]{4}\d{3}$/i,
      motorcycle: /^\d{3}[A-Z]{3}$/i,
      mercosurMotorcycle: /^\d{3}[A-Z]{4}$/i,
    } as Record<string, RegExp>,
    vehiclePlateStyles: {
      car: {
        container: { borderColor: "#E22D30", borderWidth: 2 },
        text: { color: "#E22D30", fontSize: 20, marginHorizontal: 4 },
        header: {},
        countryName: {
          marginLeft: 3,
          textAlign: "left",
        },
      },
      mercosurCar: {
        container: { borderColor: "black", borderWidth: 2 },
        text: { color: "black", fontSize: 20 },
        header: {
          backgroundColor: "#0038A8",
          justifyContent: "flex-start",
        },
        countryName: {
          color: "white",
          textAlign: "left",
          paddingLeft: 5,
        },
      },
      motorcycle: {
        container: { borderColor: "#E22D30", borderWidth: 2 },
        text: { color: "#E22D30", fontSize: 20, marginHorizontal: 4 },
        header: {},
        countryName: {
          marginLeft: 3,
          textAlign: "left",
        },
      },
      mercosurMotorcycle: {
        container: { borderColor: "black", borderWidth: 2 },
        text: { color: "black", fontSize: 20 },
        header: {
          backgroundColor: "#0038A8",
          justifyContent: "flex-start",
        },
        countryName: {
          color: "white",
          textAlign: "left",
          paddingLeft: 5,
        },
      },
    } as Record<string, PlateStyle>,
  },
  {
    label: "Argentina",
    value: "AR",
    iso: "ar",
    flag: "🇦🇷",
    coords: { latitude: -38.4161, longitude: -63.6167 },
    nearby: ["PY", "BR", "BO", "UY", "CL"],
  },
  {
    label: "Brazil",
    value: "BR",
    iso: "br",
    flag: "🇧🇷",
    coords: { latitude: -14.235, longitude: -51.9253 },
    nearby: ["AR", "PY", "BO", "UY", "CO", "VE", "PE", "SR", "GY", "GF"],
  },
  {
    label: "Bolivia",
    value: "BO",
    iso: "bo",
    flag: "🇧🇴",
    coords: { latitude: -16.2902, longitude: -63.5887 },
    nearby: ["AR", "BR", "PY", "PE", "CL"],
  },
  {
    label: "Uruguay",
    value: "UY",
    iso: "uy",
    flag: "🇺🇾",
    coords: { latitude: -32.5228, longitude: -55.7658 },
    nearby: ["AR", "BR", "PY"],
  },
  {
    label: "Germany",
    value: "DE",
    iso: "de",
    flag: "🇩🇪",
    coords: { latitude: 51.1657, longitude: 10.4515 },
    nearby: ["FR", "PL", "CZ", "AT", "CH", "NL", "BE", "LU", "DK"],
  },
  {
    label: "France",
    value: "FR",
    iso: "fr",
    flag: "🇫🇷",
    coords: { latitude: 46.6034, longitude: 1.8883 },
    nearby: ["DE", "ES", "IT", "CH", "BE", "LU", "MC", "AD"],
  },
];
